module.exports = __webpack_public_path__ + "static/img/txtbtn_arrow_more.32bdd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/txtbtn_arrow_more.png
// module id = j0HX
// module chunks = 10